import { isWhatsAppMsPlatform } from '../../../../services/inbox/inboxMsChatPlatform';

export default function canReplyToMessage({
  platform,
  canReply,
  gsIntegrated,
  isCapi
}) {
  const isMultiNumberWhatsapp = platform !== 'whatsapp' && isWhatsAppMsPlatform(platform);

  if (isMultiNumberWhatsapp) return canReply === true;

  return !gsIntegrated || (isCapi && canReply === true);
}
